var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraTabla", {
        attrs: { permisoAccion: _vm.accionCrear },
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorMantenedor", {
                  attrs: { filter: _vm.handleBusqueda }
                })
              ]
            },
            proxy: true
          },
          {
            key: "centro",
            fn: function() {
              return [
                _c("ExportarAgGridButton", {
                  attrs: {
                    permisoAccion: _vm.accionExportar,
                    "column-defs": _vm.enrichedGridOptions
                      ? _vm.enrichedGridOptions.columnDefs
                      : _vm.gridOptions.columnDefs,
                    "row-data": _vm.alertasBase,
                    "exported-file-name": "Alerta-Base"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "derecha",
            fn: function() {
              return [
                _c("CrearButton", {
                  attrs: { permisoAccion: _vm.accionCrear },
                  on: {
                    click: function($event) {
                      return _vm.handleCrearClick()
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("MantenedorGridTodos", {
        attrs: {
          "grid-options": _vm.gridOptions,
          funcionalidadId: _vm.funcionalidad
        },
        on: {
          gridOptionsEnriched: function($event) {
            _vm.enrichedGridOptions = $event
          }
        }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarConfirmacionEliminar,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.$t("mensajes.crud.eliminar.mensaje", {
            entidad: "Configuración Base"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleCierreConfirmacionEliminar }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.noPermiteEliminarConfirm,
          titulo: "Eliminar Configuración Base",
          mensaje:
            "La Configuración Base a eliminar tiene Alertas activas, debe primero desasociar, para eliminar la Configuración Base",
          mostrarBoton: false
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.noPermiteEliminarConfirm = false
          }
        }
      }),
      _c("CrearAlertasBaseModal", {
        attrs: { show: _vm.mostrarModalCrear },
        on: {
          cerrar: function($event) {
            return _vm.handleCierreModal()
          }
        }
      }),
      _c("VerAlertaBaseModal", {
        attrs: {
          show: _vm.mostrarModalVer,
          alertaBaseSeleccionada: _vm.alertaBaseSeleccionada
        },
        on: {
          cerrar: function($event) {
            return _vm.handleCierreModal()
          }
        }
      }),
      _c("EditarAlertaBaseModal", {
        attrs: {
          show: _vm.mostrarModalEditar,
          alertaBaseSeleccionada: _vm.alertaBaseSeleccionada
        },
        on: {
          cerrar: function($event) {
            return _vm.handleCierreModal()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }